// API client v2 (fetch + Bearer token). Proxy /api -> backend (package.json "proxy").
const TOKEN_KEY = 'vdh_portal_token';
export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY)),
};
async function req(method, path, body) {
  const headers = { 'content-type': 'application/json' };
  const t = tokenStore.get();
  if (t) headers.authorization = `Bearer ${t}`;
  const r = await fetch(`/api/v1${path}`, {
    method, headers, body: body === undefined ? undefined : JSON.stringify(body),
  });
  const txt = await r.text();
  const data = txt ? JSON.parse(txt) : null;
  if (!r.ok) {
    const m = (data && (data.message || data.error)) || `Lỗi ${r.status}`;
    throw new Error(Array.isArray(m) ? m.join(', ') : m);
  }
  return data;
}
export const api = {
  get: (p) => req('GET', p),
  post: (p, b) => req('POST', p, b),
  patch: (p, b) => req('PATCH', p, b),
  del: (p) => req('DELETE', p),
};
